import React from "react";
import moment from "moment";
import {
  Card,
  Col,
  Row,
  Table,
  CardHeader,
  CardBody,
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
} from "reactstrap";
import { IoMdFlag } from "react-icons/io";
import { GoCreditCard } from "react-icons/go";
import { ImCheckmark, ImCross } from "react-icons/im";
import { BsExclamationTriangleFill } from "react-icons/bs";

import * as Server from "../../Server";
import Page from "../../components/Page";
import PageSpinner from "../../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { capitalizeFirstLetter } from "../../GeneralFunctions";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";

class PlayerPaymentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      camp: {},
      playerName: "",
      transaction: {},
      cancelTransactionConfirmationModal: false,
      raiseDisputeModal: false,
      disputeTransactionId: "",
      raiseDisputeTitle: "",
      raiseDisputeDescription: "",
      reprocessTransactions: [],
      reprocessConfirmationModal: false,
      installmentReprocessTooltip: false,
      installmentSelectedIndex: null,
      subscriptionReprocessTooltip: false,
      subscriptionSelectedIndex: null,
    };
  }

  componentDidMount() {
    this.setState({
      camp: this.props.history.location.state.camp,
      playerName: this.props.history.location.state.playerName,
    });
    this.getTransaction(this.props.history.location.state.camp.transactionId);
  }

  getTransaction = async (transactionId) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushTransaction/detail/webapp",
        method: "POST",
        data: { transactionId },
        token: "marketplaceAccessToken",
      });
      if (response) {
        this.setState({
          showLoader: false,
          transaction: response.transaction,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderPaymentStatus = (installment) => {
    let installmentPaid = this.state.transaction.installmentsPaid.find(
      (installmentPaid) =>
        installmentPaid.installmentNumber === installment.installmentNumber
    );
    if (installmentPaid && installmentPaid.paymentStatus) {
      if (installmentPaid.paymentStatus === "pending") {
        return "-";
      } else if (installmentPaid.paymentStatus === "invalid") {
        return (
          <BsExclamationTriangleFill
            size="20px"
            style={{ color: "#ffc107" }}
          ></BsExclamationTriangleFill>
        );
      } else {
        if (installmentPaid.paymentStatus === "paid") {
          return (
            <ImCheckmark size="20px" style={{ color: "green" }}></ImCheckmark>
          );
        } else {
          return <ImCross size="20px" style={{ color: "red" }}></ImCross>;
        }
      }
    } else {
      return "-";
    }
  };

  renderPaymentType = (installment) => {
    let installmentPaid = this.state.transaction.installmentsPaid.find(
      (installmentPaid) =>
        installmentPaid.installmentNumber === installment.installmentNumber
    );
    if (installmentPaid && installmentPaid.paymentType) {
      return capitalizeFirstLetter(installmentPaid.paymentType);
    } else {
      return "-";
    }
  };

  raiseDispute = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushTransaction/raise/dispute",
        method: "POST",
        data: {
          transactionId: this.state.transaction._id,
          disputeTransactionId: this.state.disputeTransactionId,
          title: this.state.raiseDisputeTitle,
          description: this.state.raiseDisputeDescription,
        },
        token: "marketplaceAccessToken",
      });
      if (response) {
        this.setState({
          showLoader: false,
        });
        this.toggleRaiseDisputeModal();
        this.getTransaction(
          this.props.history.location.state.camp.transactionId
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  cancelTransaction = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "stripe/cancelSubscription",
        method: "POST",
        data: {
          cancelFor: "child",
          childId: this.state.transaction.childId,
          parentId: this.state.transaction.parentId,
          transactionId: this.state.transaction._id,
        },
        token: "marketplaceAccessToken",
      });
      if (response) {
        this.setState({
          showLoader: false,
        });
        this.toggleTransactionCancelConfirmationModal();
        this.getTransaction(
          this.props.history.location.state.camp.transactionId
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  reprocessTransactions = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccerapp/reprocess/transaction",
        method: "POST",
        data: {
          fromWeb: true,
          transactions: this.state.reprocessTransactions,
        },
        token: "marketplaceAccessToken",
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.toggleReprocessConfirmationModal();
        this.getTransaction(this.state.transaction._id);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  toggleReprocessConfirmationModal = (reprocessTransactionId) => {
    reprocessTransactionId
      ? this.setState({
          reprocessTransactions: [
            {
              transactionId: this.state.transaction._id,
              id: reprocessTransactionId,
            },
          ],
          reprocessConfirmationModal: !this.state.reprocessConfirmationModal,
        })
      : this.setState({
          reprocessConfirmationModal: !this.state.reprocessConfirmationModal,
        });
  };

  toggleTransactionCancelConfirmationModal = () => {
    this.setState({
      cancelTransactionConfirmationModal: !this.state
        .cancelTransactionConfirmationModal,
    });
  };

  toggleRaiseDisputeModal = (interval, obj) => {
    switch (interval) {
      case "onetime":
        this.setState({
          disputeTransactionId: this.state.transaction._id,
          raiseDisputeModal: !this.state.raiseDisputeModal,
        });
        break;
      case "monthly subscription":
        this.setState({
          disputeTransactionId: obj._id,
          raiseDisputeModal: !this.state.raiseDisputeModal,
        });
        break;
      case "month":
        this.setState({
          disputeTransactionId: obj._id,
          raiseDisputeModal: !this.state.raiseDisputeModal,
        });
        break;
      default:
        this.setState({
          raiseDisputeTitle: "",
          raiseDisputeDescription: "",
          raiseDisputeModal: !this.state.raiseDisputeModal,
        });
    }
  };

  renderRefundButton = (object, type, index) => {
    switch (type) {
      case "subscription":
        switch (object.paymentStatus) {
          case "failed":
            return (
              <>
                <GoCreditCard
                  id={`subscriptionReprocessTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    this.toggleReprocessConfirmationModal(
                      object._id,
                      object.paymentType
                    )
                  }
                  onMouseOver={() =>
                    this.setState({
                      subscriptionSelectedIndex: index,
                      subscriptionReprocessTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      subscriptionSelectedIndex: null,
                      subscriptionReprocessTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.subscriptionReprocessTooltip &&
                    this.state.subscriptionSelectedIndex === index
                  }
                  target={`subscriptionReprocessTooltip${index}`}
                  toggle={() => {}}
                >
                  Reprocess Transaction
                </Tooltip>
              </>
            );
          case "refund":
            return "-";
          case "invalid":
            return "-";
          default:
            return "-";
        }
      case "installment":
        let installmentsPaid = this.state.transaction.installmentsPaid.find(
          (installment) =>
            installment.installmentNumber === object.installmentNumber
        );
        switch (installmentsPaid.paymentStatus) {
          case "failed":
            return (
              <>
                <GoCreditCard
                  id={`installmentReprocessTooltip${index}`}
                  size="25px"
                  style={{
                    outline: "unset",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    this.toggleReprocessConfirmationModal(
                      installmentsPaid._id,
                      installmentsPaid.paymentType
                    )
                  }
                  onMouseOver={() =>
                    this.setState({
                      installmentSelectedIndex: index,
                      installmentReprocessTooltip: true,
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      installmentSelectedIndex: null,
                      installmentReprocessTooltip: false,
                    })
                  }
                />
                <Tooltip
                  placement="bottom"
                  isOpen={
                    this.state.installmentReprocessTooltip &&
                    this.state.installmentSelectedIndex === index
                  }
                  target={`installmentReprocessTooltip${index}`}
                  toggle={() => {}}
                >
                  Reprocess Transaction
                </Tooltip>
              </>
            );
          case "refund":
            return "-";
          case "invalid":
            return "-";
          default:
            return "-";
        }
      default:
        return null;
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Player Payment Detail"
          breadcrumbs={[{ name: "Player Payment Detail", active: true }]}
        >
          <Row style={{ marginTop: 10 }}>
            <Col>
              <Card>
                <div
                  style={{
                    margin: 20,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexShrink: 1,
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      padding: 5,
                    }}
                  >
                    <div style={{ fontSize: 30 }}>
                      {this.state.camp.campName}
                    </div>
                  </div>
                  <Row>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Transaction Id
                      </div>
                      <div style={{ fontSize: 15 }}>
                        {this.state.camp.transactionId}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Issue Date
                      </div>
                      <div style={{ fontSize: 15 }}>
                        {moment
                          .utc(this.state.transaction.createdAt)
                          .format("LL")}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Status
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        {this.state.camp.status
                          ? capitalizeFirstLetter(this.state.camp.status)
                          : "-"}
                      </div>
                    </Col>
                    <Col>
                      <h4 style={{ fontSize: 30, color: "rgb(23, 81, 123)" }}>
                        {this.state.playerName}
                      </h4>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 20 }}>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        {this.state.transaction.interval === "onetime"
                          ? "Payment Id"
                          : this.state.transaction.interval === "month"
                          ? "Installment Id"
                          : "Subscritpion Id"}
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        {(this.state.transaction.data &&
                          this.state.transaction.data.id) ||
                          "-"}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Payment Status
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        {this.state.transaction.status &&
                          capitalizeFirstLetter(this.state.transaction.status)}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Total amount
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        ${Number(this.state.transaction.campPrice).toFixed(2)}
                      </div>
                    </Col>
                    <Col>
                      <div style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}>
                        Balance Due
                      </div>
                      <div style={{ fontSize: 15, fontWeight: "bold" }}>
                        $
                        {Number(this.state.transaction.pendingPrice).toFixed(2)}
                      </div>
                    </Col>
                    {this.state.transaction.status === "refund" && (
                      <Col>
                        <div
                          style={{ fontSize: 15, color: "rgb(23, 81, 123)" }}
                        >
                          Refunded Amount
                        </div>
                        <div style={{ fontSize: 15, fontWeight: "bold" }}>
                          ${this.state.transaction.refundData.amount / 100}
                        </div>
                      </Col>
                    )}
                  </Row>
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-end">
                        {this.state.transaction.interval !== "onetime" &&
                        this.state.transaction.status !== "cancelled" &&
                        this.state.transaction.camp &&
                        this.state.transaction.camp.showCancelButton ? (
                          <Button
                            id="toggler"
                            className="mr-4"
                            onClick={() =>
                              this.toggleTransactionCancelConfirmationModal()
                            }
                          >
                            Cancel Subscritpion
                          </Button>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </div>
              </Card>
              <Row>
                <Col>
                  <Card className="mt-3">
                    <CardHeader>Payment Plan</CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <Card body>
                            {this.state.transaction.interval === "onetime" ? (
                              //For full payment data
                              <Table bordered responsive>
                                <thead>
                                  <tr>
                                    <th>Raise Dispute</th>
                                    <th>Event Price</th>
                                    <th>Discount Price</th>
                                    <th>Credit Amount</th>
                                    <th>Due Amount</th>
                                    <th>Amount Paid</th>
                                    <th>Processing Fee</th>
                                    <th>Payment Status</th>
                                    <th>Paid on</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {this.state.transaction.disputeRaised ? (
                                        <IoMdFlag
                                          size="27px"
                                          style={{
                                            color: "#ff7c00",
                                          }}
                                        />
                                      ) : (
                                        <IoMdFlag
                                          size="27px"
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            this.toggleRaiseDisputeModal(
                                              "onetime",
                                              {}
                                            )
                                          }
                                        />
                                      )}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.campPrice
                                        ? this.state.transaction.campPrice.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.discountPrice
                                        ? this.state.transaction.discountPrice.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.creditAmount
                                        ? this.state.transaction.creditAmount.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.dueAmount
                                        ? this.state.transaction.dueAmount.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.price
                                        ? this.state.transaction.price.toFixed(
                                            2
                                          )
                                        : "0.00"}
                                    </td>
                                    <td>
                                      ${" "}
                                      {this.state.transaction.price !== 0
                                        ? (
                                            this.state.transaction.data
                                              .application_fee_amount / 100
                                          ).toFixed(2)
                                        : "0.00"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {this.state.transaction.status &&
                                      this.state.transaction.status ===
                                        "paid" ? (
                                        <ImCheckmark
                                          size="20px"
                                          style={{ color: "green" }}
                                        ></ImCheckmark>
                                      ) : (
                                        <ImCross
                                          size="20px"
                                          style={{ color: "red" }}
                                        ></ImCross>
                                      )}
                                    </td>
                                    <td>
                                      {moment
                                        .utc(this.state.transaction.createdAt)
                                        .format("LL")}
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            ) : this.state.transaction.interval ===
                              "monthly subscription" ? (
                              //For monthly subscription data
                              <Table bordered responsive>
                                <thead>
                                  <tr>
                                    <th>Raise Dispute</th>
                                    <th>Due Date</th>
                                    <th>Subscription Price</th>
                                    <th>Discount Price</th>
                                    <th>Credit Amount</th>
                                    <th>Due Amount</th>
                                    <th>Amount Paid</th>
                                    <th>Processing Fee</th>
                                    <th>Payment Status</th>
                                    <th>Paid on</th>
                                    <th>Payment Type</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.transaction.subscriptions &&
                                    this.state.transaction.subscriptions.map(
                                      (subscription, index) => (
                                        <tr key={index}>
                                          <td
                                            style={{
                                              textAlign: "center",
                                            }}
                                          >
                                            {subscription.paidOn ? (
                                              subscription.disputeRaised ? (
                                                <IoMdFlag
                                                  size="27px"
                                                  style={{
                                                    color: "#ff7c00",
                                                  }}
                                                />
                                              ) : (
                                                <IoMdFlag
                                                  size="27px"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.toggleRaiseDisputeModal(
                                                      "monthly subscription",
                                                      subscription
                                                    )
                                                  }
                                                />
                                              )
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                          <td>
                                            {moment
                                              .utc(subscription.dueDate)
                                              .format("LL")}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.price
                                              ? subscription.price.toFixed(2)
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.teamDiscountAmount
                                              ? subscription.teamDiscountAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.creditAmount
                                              ? subscription.creditAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.dueAmount
                                              ? subscription.dueAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.totalPrice
                                              ? subscription.totalPrice.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {subscription.processingFeesType &&
                                            subscription.processingFeesType ===
                                              "includeProcessingFees"
                                              ? subscription.application_fee_amount.toFixed(
                                                  2
                                                )
                                              : subscription.processingFee.toFixed(
                                                  2
                                                )}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {subscription.paymentStatus &&
                                            subscription.paymentStatus ===
                                              "pending" ? (
                                              "-"
                                            ) : subscription.paymentStatus ===
                                              "invalid" ? (
                                              <BsExclamationTriangleFill
                                                size="20px"
                                                style={{ color: "#ffc107" }}
                                              ></BsExclamationTriangleFill>
                                            ) : subscription.paymentStatus ===
                                              "paid" ? (
                                              <ImCheckmark
                                                size="20px"
                                                style={{ color: "green" }}
                                              ></ImCheckmark>
                                            ) : (
                                              <ImCross
                                                size="20px"
                                                style={{ color: "red" }}
                                              ></ImCross>
                                            )}
                                          </td>
                                          <td>
                                            {subscription.paidOn
                                              ? moment
                                                  .utc(subscription.paidOn)
                                                  .format("LL")
                                              : "-"}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {subscription.paymentType
                                              ? capitalizeFirstLetter(
                                                  subscription.paymentType
                                                )
                                              : "-"}
                                          </td>
                                          <td>
                                            {subscription.paidOn
                                              ? this.renderRefundButton(
                                                  subscription,
                                                  "subscription",
                                                  index
                                                )
                                              : null}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </Table>
                            ) : (
                              //For installment data
                              <Table bordered responsive>
                                <thead>
                                  <tr>
                                    <th>Raise Dispute</th>
                                    <th>Due Date</th>
                                    <th>Installment Price</th>
                                    <th>Discount Price</th>
                                    <th>Credit Amount</th>
                                    <th>Due Amount</th>
                                    <th>Amount Paid</th>
                                    <th>Processing Fee</th>
                                    <th>Payment Status</th>
                                    <th>Paid on</th>
                                    <th>Payment Type</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.transaction
                                    .installmentsCreatedPlans &&
                                    this.state.transaction.installmentsCreatedPlans.map(
                                      (installmentsCreatedPlan, index) => (
                                        <tr key={index}>
                                          <td
                                            style={{
                                              textAlign: "center",
                                            }}
                                          >
                                            {installmentsCreatedPlan.paidOn ? (
                                              installmentsCreatedPlan.disputeRaised ? (
                                                <IoMdFlag
                                                  size="27px"
                                                  style={{
                                                    color: "#ff7c00",
                                                  }}
                                                />
                                              ) : (
                                                <IoMdFlag
                                                  size="27px"
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.toggleRaiseDisputeModal(
                                                      "month",
                                                      installmentsCreatedPlan
                                                    )
                                                  }
                                                />
                                              )
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                          <td>
                                            {moment
                                              .utc(
                                                installmentsCreatedPlan.dueDate
                                              )
                                              .format("LL")}
                                          </td>
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.campPricePerInstallment
                                              ? installmentsCreatedPlan.campPricePerInstallment.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.teamDiscountAmount
                                              ? installmentsCreatedPlan.teamDiscountAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.creditAmount
                                              ? installmentsCreatedPlan.creditAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.dueAmount
                                              ? installmentsCreatedPlan.dueAmount.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </td>
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.price.toFixed(
                                              2
                                            )}
                                          </td>
                                          <td>
                                            ${" "}
                                            {installmentsCreatedPlan.processingFeesType &&
                                            installmentsCreatedPlan.processingFeesType ===
                                              "includeProcessingFees"
                                              ? installmentsCreatedPlan.application_fee_amount.toFixed(
                                                  2
                                                )
                                              : installmentsCreatedPlan.processingFee.toFixed(
                                                  2
                                                )}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {this.renderPaymentStatus(
                                              installmentsCreatedPlan
                                            )}
                                          </td>
                                          <td>
                                            {installmentsCreatedPlan.paidOn
                                              ? moment
                                                  .utc(
                                                    installmentsCreatedPlan.paidOn
                                                  )
                                                  .format("LL")
                                              : "-"}
                                          </td>
                                          <td style={{ textAlign: "center" }}>
                                            {this.renderPaymentType(
                                              installmentsCreatedPlan
                                            )}
                                          </td>
                                          <td>
                                            {installmentsCreatedPlan.paidOn
                                              ? this.renderRefundButton(
                                                  installmentsCreatedPlan,
                                                  "installment",
                                                  index
                                                )
                                              : null}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                </tbody>
                              </Table>
                            )}
                          </Card>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Col style={{ padding: 0 }}>
                <Card className="mb-3 mt-3">
                  <CardHeader>Transaction History</CardHeader>
                  <CardBody>
                    <Row>
                      <Col>
                        <Card body>
                          {this.state.transaction.interval === "onetime" ? (
                            <Table bordered responsive>
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Transaction</th>
                                  <th>Note</th>
                                  <th>Payment Status</th>
                                  <th>Payment Type</th>
                                  <th>Amount</th>
                                  <th>View Receipt</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    {moment
                                      .utc(this.state.transaction.createdAt)
                                      .format("LL")}
                                  </td>
                                  <td>
                                    Transaction {this.state.transaction._id} ·{" "}
                                    {this.state.transaction.status.toUpperCase()}{" "}
                                    · Payment Intent Id:{" "}
                                    {this.state.transaction.data.id
                                      ? this.state.transaction.data.id
                                      : "-"}
                                  </td>
                                  <td>
                                    {this.state.transaction.note
                                      ? capitalizeFirstLetter(
                                          this.state.transaction.note
                                        )
                                      : "-"}
                                  </td>
                                  <td>
                                    {this.state.transaction &&
                                      capitalizeFirstLetter(
                                        this.state.transaction.status
                                      )}
                                  </td>
                                  <td>
                                    {this.state.transaction.paymentType
                                      ? this.state.transaction.paymentType ===
                                        "bank_debit"
                                        ? "Ach_debit"
                                        : capitalizeFirstLetter(
                                            this.state.transaction.paymentType
                                          )
                                      : "-"}
                                  </td>
                                  <td>
                                    $ {this.state.transaction.price.toFixed(2)}
                                  </td>
                                  <td>
                                    <a
                                      href={
                                        this.state.transaction.data.receipt_url
                                          ? this.state.transaction.data
                                              .receipt_url
                                          : this.state.transaction.data.charges
                                          ? this.state.transaction.data.charges
                                              .data[0].receipt_url
                                          : "https://zocial.io/noReceipt.html"
                                      }
                                      target="_blank"
                                    >
                                      View
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          ) : this.state.transaction.interval ===
                            "monthly subscription" ? (
                            <Table bordered responsive>
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Transaction</th>
                                  <th>Note</th>
                                  <th>Payment Status</th>
                                  <th>Payment Type</th>
                                  <th>Amount</th>
                                  <th>View Receipt</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.transaction.subscriptions &&
                                  this.state.transaction.subscriptions.map(
                                    (subscription, index) => (
                                      <tr key={index}>
                                        <td>
                                          {subscription.paidOn
                                            ? moment
                                                .utc(subscription.paidOn)
                                                .format("LL")
                                            : moment
                                                .utc(subscription.dueDate)
                                                .format("LL")}
                                        </td>
                                        <td>Transaction {subscription._id}</td>
                                        <td>
                                          {subscription.note
                                            ? capitalizeFirstLetter(
                                                subscription.note
                                              )
                                            : "-"}
                                        </td>
                                        <td>
                                          {subscription.paymentStatus.toUpperCase()}
                                        </td>
                                        <td>
                                          {subscription.paymentType
                                            ? capitalizeFirstLetter(
                                                subscription.paymentType
                                              )
                                            : "-"}
                                        </td>
                                        <td>
                                          ${" "}
                                          {subscription.totalPrice
                                            ? subscription.totalPrice.toFixed(2)
                                            : "0.00"}
                                        </td>
                                        <td>
                                          {subscription.hosted_invoice_url ? (
                                            <a
                                              href={
                                                subscription.hosted_invoice_url
                                              }
                                              target="_blank"
                                            >
                                              View
                                            </a>
                                          ) : (
                                            "-"
                                          )}
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </Table>
                          ) : (
                            <Table bordered responsive>
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Transaction</th>
                                  <th>Note</th>
                                  <th>Payment Status</th>
                                  <th>Payment Type</th>
                                  <th>Amount</th>
                                  <th>View Receipt</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.transaction.installmentsPaid &&
                                  this.state.transaction.installmentsPaid.map(
                                    (installmentPaid, index) => (
                                      <tr key={index}>
                                        <td>
                                          {moment
                                            .utc(installmentPaid.paidOn)
                                            .format("LL")}
                                        </td>
                                        <td>
                                          Installment Number :{" "}
                                          {installmentPaid.installmentNumber} ·{" "}
                                          Installment Id : {installmentPaid._id}{" "}
                                          ·{" "}
                                          {installmentPaid.paymentStatus.toUpperCase()}{" "}
                                        </td>
                                        <td>
                                          {installmentPaid.note
                                            ? capitalizeFirstLetter(
                                                installmentPaid.note
                                              )
                                            : "-"}
                                        </td>
                                        <td>
                                          {capitalizeFirstLetter(
                                            installmentPaid.paymentStatus
                                          )}
                                        </td>
                                        <td>
                                          {capitalizeFirstLetter(
                                            installmentPaid.paymentType
                                          )}
                                        </td>
                                        <td>$ {installmentPaid.price}</td>
                                        <td>
                                          <a
                                            href={
                                              installmentPaid.hosted_invoice_url
                                            }
                                            target="_blank"
                                          >
                                            View
                                          </a>
                                        </td>
                                      </tr>
                                    )
                                  )}
                              </tbody>
                            </Table>
                          )}
                          <Row>
                            <Col sm={12} md={12} lg={12} xl={12}>
                              <div className="d-flex justify-content-center">
                                <Button onClick={this.props.history.goBack}>
                                  Cancel
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Col>
          </Row>
          {this.state.raiseDisputeModal ? (
            <Modal
              isOpen={this.state.raiseDisputeModal}
              toggle={(event) => this.toggleRaiseDisputeModal()}
              className="modal-md"
            >
              <ModalHeader toggle={(event) => this.toggleRaiseDisputeModal()}>
                Raise Dispute
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Title</Label>
                      <Input
                        required
                        type="text"
                        placeholder="Title"
                        value={this.state.raiseDisputeTitle}
                        onChange={(event) =>
                          this.setState({
                            raiseDisputeTitle: event.target.value,
                          })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12} lg={12} md={12}>
                    <FormGroup>
                      <Label>Add Note</Label>
                      <Input
                        required
                        type="text"
                        placeholder="Description"
                        value={this.state.raiseDisputeDescription}
                        onChange={(event) =>
                          this.setState({
                            raiseDisputeDescription: event.target.value,
                          })
                        }
                      ></Input>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() => this.toggleRaiseDisputeModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={() => {
                    this.raiseDispute();
                  }}
                >
                  Raise
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.cancelTransactionConfirmationModal ? (
            <Modal
              isOpen={this.state.cancelTransactionConfirmationModal}
              toggle={(event) =>
                this.toggleTransactionCancelConfirmationModal()
              }
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) =>
                  this.toggleTransactionCancelConfirmationModal()
                }
              >
                Cancel Transaction
              </ModalHeader>
              <ModalBody>
                Are you sure you want to cancel transaction?
              </ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={() =>
                    this.toggleTransactionCancelConfirmationModal()
                  }
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={() => {
                    this.cancelTransaction();
                  }}
                >
                  Submit
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          {this.state.reprocessConfirmationModal ? (
            <Modal
              isOpen={this.state.reprocessConfirmationModal}
              toggle={(event) => this.toggleReprocessConfirmationModal()}
              className="modal-md"
            >
              <ModalHeader
                toggle={(event) => this.toggleReprocessConfirmationModal()}
              >
                Reprocess Transaction
              </ModalHeader>
              <ModalBody>Are you sure you want to reprocess?</ModalBody>
              <ModalFooter>
                <Button
                  color="secondary"
                  onClick={(event) => this.toggleReprocessConfirmationModal()}
                >
                  Cancel
                </Button>{" "}
                <Button
                  color="primary"
                  onClick={(event) => {
                    this.reprocessTransactions();
                  }}
                >
                  Reprocess
                </Button>
              </ModalFooter>
            </Modal>
          ) : null}
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default PlayerPaymentDetails;
